<script lang="ts">
	import { AppBar } from '@shared/svelte-kit';
	import { getAppBarViewModel } from './app-bar-view-model';
	import Avatar from './components/Avatar.svelte';
	import t from '$i18n';
	import AppLogo from './components/AppLogo.svelte';
	import ProjectSelector from './project-selector/ProjectSelector.svelte';
	import ProjectActions from './project-actions/ProjectActions.svelte';
	import { IconButton } from '@shared/svelte';

	const viewModel = getAppBarViewModel();

	const { currentRoute, isLoggedIn, showProjectSelector } = viewModel;

	$: getAppBarTitle = () => {
		switch ($currentRoute) {
			case 'account':
				return $t.account_settings_app_bar_title();
			case 'workspace':
				return $t.workspace_app_bar_title();
			default:
				return;
		}
	};

	$: appBarTitle = getAppBarTitle();
</script>

<AppBar>
	<div slot="app-logo" class={'mx-4'}>
		<AppLogo link={'/'} />
	</div>

	<span slot="left" class="flex items-center">
		{#if appBarTitle}
			<div class="min-w-6rem">
				<span class="two-lines text-2xl font-medium text-text">
					{appBarTitle}
				</span>
			</div>
		{/if}

		{#if $isLoggedIn && $showProjectSelector}
			<div class="min-w-6rem">
				<ProjectSelector />
			</div>
			<IconButton
				icon="pencil"
				size={10}
				hint="Edit project"
				on:click={() => viewModel.edit()} />
		{/if}
	</span>

	<span slot="right" class="flex items-center gap-2">
		{#if $isLoggedIn}
			{#if $showProjectSelector}
				<ProjectActions />
			{/if}
		{/if}
	</span>

	<span slot="actions">
		{#if $isLoggedIn}
			<div class="ml-4 flex gap-3 border-l border-neutral-100 pl-2">
				<Avatar viewModel={viewModel} />
			</div>
		{/if}
	</span>

	<slot name="banner" slot="banner" />
</AppBar>
